import { useState } from 'react';
import { useSelector } from 'react-redux';
import { getCurrentOrg } from 'js/reducers/selectors';

const SourceConfig = {
  'schema.detection.once': true,
  advanced_settings: 'Auto Detect',
};

export function useFileUploadTab({ sourceID }) {
  const state = useSelector((s) => s) as any;
  const [selectedFile, setSelectedFile] = useState(null);
  const [sourceConfiguration, setSourceConfiguration] = useState(SourceConfig);

  const selectedConnection = 'file_upload';
  const source = sourceID ? state.entities.sources[sourceID] : null;

  return {
    selectedFile,
    setSelectedFile,
    source,
    selectedConnection,
    sourceConfiguration,
    setSourceConfiguration,
    currentOrg: getCurrentOrg(state),
  };
}
